// extracted by mini-css-extract-plugin
export var modalFooter = "_pv-0";